import UserLoginInfoSettings from './UserLoginInfoSettings'

export default UserLoginInfoSettings
